module.exports = __webpack_public_path__ + "static/media/camera.6db80031.svg";